import React from 'react';

import VideoBlock from '@/ui/VideoBlock/VideoBlock';
import MainBanner from '@/ui/MainBanner/MainBanner';
import {
  Banner,
  ProductStatus,
  SearchTravel,
  Advantageous,
  CardBlock,
  StepsBannerWithTabsVolte,
  DocumentCard,
  AddressCards,
  PaymentCards,
  BusinessSectionBannersWithIcon,
  Bundles,
  BusinessContactForm,
  SearchList,
} from '@/ui/index';
import { InfoQuestion, Flash } from '@/icons/index';
import OurManagement from '@/ui/OurManagement/OurManagement';
import { widgetOptions } from '@/constants/widgets';
import BoardOfDirectors from '@/ui/BoardOfDirectors/BoardOfDirectors';
import MediaInquire from '@/ui/MediaInquire/MediaInquire';
import Company from '@/ui/Company/Company';

import NewsSingle from '../news/NewsSingle/NewsSingle';
import {
  AppBanner,
  BookNumber,
  BrandSlider,
  FixServices,
  NewsList as News,
  Tariffs,
  TechnicalSolutions,
} from '../home';
import NewsList from '../news/NewsList/NewsList';
import {
  BannerAzer,
  GeneralServices,
  Questions,
  Steps,
  InternetActivation,
  RoamingActivation,
} from '../roaming';
import BusinessTariffSlider from '../TariffSliderBusiness/TariffSliderBusiness';
import MapContainer from '../common/GoogleMapsClusterer/GoogleMapsClusterer';
import TariffsFilter from '../common/TariffsFilter';
import Form from '../partnership/Form/Form';
import { CampaignList, CampaignTable } from '../campaigns';
import {
  SingleTariffsContent,
  SingleTariffsTabs,
  FindBundle,
} from '../tariffs';
import { OfficesList } from '../contact-us';
import {
  ServicesOperations,
  ServiceReverse,
  ServiceVideo,
  CheckCompatibility,
  ServiceContent,
  ServiceSlider,
  ServicesGrid,
} from '../services';
import {
  Awards,
  Vacancies,
  ColorCards,
  Milestones,
  TitleBlock,
} from '../about-us';
import { WhyBlock, BusinessJoinUs } from '../business-join-us';
import ChooseTopicWidget from '../choose-topic/ChooseTopic';
import { ChooseCategory } from '../support';
import BusinessTariffSliderWithoutHeader from '../TariffSliderBusiness/TariffSliderBusinessWithoutHeader';
import { InfoBlock } from '../business-calls';
import { FindYourNumberFlow } from '../find-your-number';
import FixService from '../business-fix-service/FixService';
import { Advantageous as BusinessAdvantageous } from '../business-roaming';
import { FindYourEsimFlow } from '../esim';

const WidgetWrapper = ({ widgets }) => {
  const renderWidgets = (name, data) => {
    switch (name) {
      case widgetOptions.SLIDER:
        return <BrandSlider data={data} business />;
      case widgetOptions.BEAUTIFUL_NUMBERS:
        return <BookNumber tabs={data} />;
      case widgetOptions.RED_BANNER:
        return <Banner item={data} isBusiness />;
      case widgetOptions.APPLICATION_BANNER:
        return <AppBanner className='wrapper section' item={data} />;
      case widgetOptions.NEWS_SLIDER:
        return <News className='wrapper section' data={data} />;
      case widgetOptions.IMAGE_BANNER:
      case widgetOptions.BLACK_BANNER:
        return <Banner item={data} type='red_banner' isBusiness />;
      case widgetOptions.GRAY_BANNER:
        return <BusinessContactForm bannerData={data} />;
      case widgetOptions.TARIFF_SLIDER:
        return (
          <Tariffs
            data={data}
            footerData={data?.tags}
            title={data?.title}
            buttonText={data?.button_text}
          />
        );
      case widgetOptions.GENERAL_SERVICE:
        return <GeneralServices services={data} />;
      case widgetOptions.IMPORTANT_STEP:
        return <Steps data={data} />;
      case widgetOptions.FOR_FOREIGN_GUEST:
        return <BannerAzer data={data} />;
      case widgetOptions.ACCORDION:
        return (
          <Questions
            questions={data}
            className='wrapper'
            titleModify='title--large'
          />
        );

      case widgetOptions.HEADER:
        return <MainBanner dark data={data} />;
      case widgetOptions.ROAMING_COUNTRY_SEARCH:
        return <SearchTravel data={data} />;
      case widgetOptions.HOTSPOT_MAP:
        return <MapContainer data={data} />;
      case widgetOptions.NEW_CAMPAIGN:
        return <CampaignList data={data} />;
      case widgetOptions.TARIFF_DETAILS:
        return <SingleTariffsContent data={data} />;
      case widgetOptions.FIND_OUR_OFFICE:
        return <OfficesList data={data} />;
      case widgetOptions.HEADER_LINKS:
        return <SingleTariffsTabs tabs={data.links} />;
      case widgetOptions.TARIFF_CHOICE:
        return <FindBundle data={data} />;
      case widgetOptions.TARIFF_FILTER:
        return <TariffsFilter data={data} />;
      case widgetOptions.ADVANTAGEOUS_PRICE:
        return <Advantageous advantageousData={data} />;
      case widgetOptions.FIND_YOUR_NUMBER_ESIM:
        return <FindYourEsimFlow detail={data} />;
      case widgetOptions.ABOUT_ACTIVATION:
        return (
          <ProductStatus
            statusData={data}
            className='wrapper small-margin'
            isBlock
            titleModify='title--large'
            Icon={InfoQuestion}
          />
        );
      case widgetOptions.OPERATION_LIST:
        return (
          <ServicesOperations className='wrapper small-margin' data={data} />
        );
      case widgetOptions.GENERAL_INFORMATION:
        return <ServiceReverse data={data} className='wrapper section' />;
      case widgetOptions.VIDEO:
        return <ServiceVideo className='wrapper section' data={data} />;
      case widgetOptions.SIMPLE_APPLICATION_BANNER:
        return (
          <Banner
            item={data}
            type={'image_banner'}
            href={'/1212'}
            buttonHide
            dangerTitle
          />
        );
      case widgetOptions.WHITE_CARDS:
        return (
          <CardBlock
            className='small-margin wrapper'
            data={data}
            gridValue={data?.cards?.length}
          />
        );
      case widgetOptions.VOLTE_BANNER:
        return (
          <StepsBannerWithTabsVolte className='section wrapper' data={data} />
        );
      case widgetOptions.HORIZONTAL_TABLE:
        return (
          <CampaignTable
            data={data}
            className='wrapper small-margin'
            isHorisontal
          />
        );
      case widgetOptions.VERTICAL_TABLE:
        return (
          <CampaignTable
            data={data}
            Icon={Flash}
            className='wrapper small-margin'
          />
        );
      case widgetOptions.VOLTE_DEVICE_SEARCH:
        return <CheckCompatibility data={data} className='section wrapper' />;
      case widgetOptions.COMPANY_AWARD:
        return <Awards data={data} className='wrapper small-margin' />;
      case widgetOptions.COLOR_CARD:
        return <ColorCards data={data} className='wrapper section' />;
      case widgetOptions.KEY_MILESTONE:
        return (
          <Milestones className='wrapper small-margin' data={data} isSmall />
        );
      case widgetOptions.OPEN_POSITION:
        return <Vacancies data={data} className='wrapper small-margin' />;
      case widgetOptions.CORPORATE_SOCIAL_RESPONSIBILITY:
        return <TitleBlock data={data} className='section wrapper' />;
      case widgetOptions.SMALL_CONTENT_BLOCK:
        return <ServiceContent data={data} className='wrapper section' />;
      case widgetOptions.GALLERY:
        return <ServiceSlider data={data} className='wrapper section' />;
      case widgetOptions.OUR_MANAGEMENT:
        return <OurManagement data={data} />;
      case widgetOptions.BOARD_OF_DIRECTORS:
        return <BoardOfDirectors data={data} />;
      case widgetOptions.MEDIA_INQUIRE:
        return <MediaInquire data={data} />;
      case widgetOptions.SUSTAINABILITY:
        return <DocumentCard data={data} className={'wrapper section'} />;
      case widgetOptions.ADDRESS_CARDS:
        return <AddressCards data={data} className={'wrapper section'} />;
      case widgetOptions.COMPANY:
        return <Company data={data} />;
      case widgetOptions.PAYMENT_SYSTEMS:
        return <PaymentCards data={data} className={'wrapper section'} />;
      case widgetOptions.PARTNERSHIP_REQUEST:
        return <Form data={data} />;
      case widgetOptions.LATEST_NEWS:
        return <NewsList title={data?.title} />;
      case widgetOptions.CHOOSE_TOPIC_SECTION:
        return <ChooseTopicWidget data={data} />;
      case widgetOptions.POST_WIDGET:
        return <NewsSingle data={data} />;
      case widgetOptions.TOPIC_GROUPS:
        return <ChooseCategory data={data} className={'wrapper section'} />;
      case widgetOptions.INFO_BLOCK:
        return <InfoBlock className='wrapper section' data={data} />;
      case widgetOptions.WHY_BAKCELL:
        return <WhyBlock data={data} className='wrapper section' />;
      case widgetOptions.INFO_BOX:
        return (
          <BusinessSectionBannersWithIcon
            data={data}
            className={'wrapper section'}
          />
        );
      case widgetOptions.FIND_YOUR_NUMBER:
        return <FindYourNumberFlow data={data} />;
      case widgetOptions.BUSINNES_CARD:
        return <BusinessJoinUs data={data} />;
      case widgetOptions.VIDEO_BLOG:
        return <VideoBlock data={data} />;
      case widgetOptions.FIX_SERVICE:
        return <FixServices data={data} />;
      case widgetOptions.TECHNICAL_SOLUTION:
        return <TechnicalSolutions data={data} />;
      case widgetOptions.PRICING_TABLE:
        return <FixService data={data} />;

      case widgetOptions.TARIFF_SLIDER_BUSINESS:
        return <BusinessTariffSlider data={data} />;
      case widgetOptions.M2M_BUNDLES:
        return <Bundles data={data} className='wrapper card-margin' />;
      case widgetOptions.BUSINESS_ADVANTAGEOUS_PRICE:
        return <BusinessAdvantageous data={data} />;
      case widgetOptions.INTERNET_ACTIVATION:
        return <InternetActivation data={data} />;
      case widgetOptions.ROAMING_ACTIVATION_BUSINESS:
        return <RoamingActivation data={data} />;
      case widgetOptions.ROAMING_COUNTRY_SEARCH_BUSINESS:
        return <SearchTravel data={data} />;
      case widgetOptions.TARIFF_SLIDER_BUSINESS_WITHOUT_HEADER:
        return <BusinessTariffSliderWithoutHeader data={data} />;
      case widgetOptions.SERVICES:
        return <ServicesGrid data={data} />;
      case widgetOptions.SEARCH_RESULT_WIDGET:
        return <SearchList data={data} />;
      default:
        return <div className='wrapper'>{name} not found</div>;
    }
  };
  return <>{widgets?.map((item) => renderWidgets(item.type, item))}</>;
};

export default WidgetWrapper;
